<!-- eslint-disable no-useless-escape -->
<template>
  <div v-loading="oLoading.detail">
    <QS-scroller-box>
      <QS-h3-title>
        <template slot="title"
          >编辑维保信息</template
        >
      </QS-h3-title>
      <div class="splitline mt16 mb16"></div>
      <el-form
        class="infor"
        :label-width="labelWidth"
        ref="source_from"
        :model="source"
        :rules="rules"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item :label="`维保单ID${columnSeparator}`">
              {{ source.id || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="'维保类型' + columnSeparator" prop="type">
              <el-select
                placeholder="请选择"
                v-model="source.type"
                @change="handleType"
                clearable
              >
                <el-option
                  v-for="item in maintenanceTypList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="'服务商' + columnSeparator" prop="providerId">
              <el-select
                placeholder="请选择"
                v-model="source.providerId"
                clearable
              >
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" v-for="item in list" :key="item.key">
            <el-form-item :label="item.name + columnSeparator">
              {{ source[item.key] || '--' }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item
              :label="'进厂时间' + columnSeparator"
              prop="incomeTime"
            >
              <el-date-picker
                v-model="source.incomeTime"
                type="datetime"
                placeholder="选择日期时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="incomeTimeOption"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="'来源类型' + columnSeparator"
              prop="sourceType"
            >
              <span>录入</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="'计划出厂时间' + columnSeparator"
              prop="estimateLeaveTime"
            >
              <el-date-picker
                v-model="source.estimateLeaveTime"
                type="datetime"
                placeholder="选择日期时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="estimateLeaveTimeOption"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="'维保总费用' + columnSeparator">
              <el-input
                :disabled="totalDisabled"
                v-model="source.totalAmount"
                maxlength="18"
                v-limit-money="true"
              >
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="'客户承担维保金额' + columnSeparator">
              <el-input
                v-model="source.customerAmount"
                :disabled="totalDisabled"
                maxlength="18"
                v-limit-money="true"
              >
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="'维保状态' + columnSeparator"
              prop="maintenanceState"
            >
              <el-select
                placeholder="请选择"
                v-model="source.maintenanceState"
                clearable
              >
                <el-option
                  v-for="item in maintenanceStateList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="'结算状态' + columnSeparator"
              prop="settlementState"
            >
              <el-select
                placeholder="请选择"
                v-model="source.settlementState"
                clearable
              >
                <el-option
                  v-for="item in settlementStatusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="'出厂时间' + columnSeparator">
              <el-date-picker
                v-model="source.leaveTime"
                type="datetime"
                placeholder="选择日期时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="leaveTimeOption"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="'进厂公里数' + columnSeparator"
              prop="incomeKm"
            >
              <el-input
                v-model="source.incomeKm"
                placeholder="请输入"
                v-number:km
              >
                <template slot="append"
                  >公里</template
                >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="source.type === 2">
            <el-form-item
              :label="'上次保养里程' + columnSeparator"
              prop="lastMaintenanceKm"
            >
              <el-input
                v-model="source.lastMaintenanceKm"
                placeholder="请输入"
                v-number:km
              >
                <template slot="append"
                  >公里</template
                >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="source.type === 2">
            <el-form-item
              :label="'超保里程' + columnSeparator"
              prop="overMaintenanceKm"
            >
              <el-input
                v-model="source.overMaintenanceKm"
                placeholder="请输入"
                v-number:km
              >
                <template slot="append"
                  >公里</template
                >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item
              :label="'处理备注' + columnSeparator"
              prop="remarks"
              class="alone"
            >
              <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入"
                v-model="source.remarks"
                maxlength="500"
                show-word-limit
                @input="changeRemarks"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="'送修原因' + columnSeparator"
              class="alone"
              prop="reasonForRepair"
            >
              <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入"
                v-model.trim="source.reasonForRepair"
                maxlength="500"
                show-word-limit
                @input="changeReasonForRepair"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" class="specail_upload">
            <el-form-item :label="'结算单附件' + columnSeparator" class="alone">
              <UploadCommon
                :fileList="fileList"
                listType="text"
                :limit="20"
                :sizeType="4"
                commonUpload
                group="assert"
                code="assert_settlement_list"
                multiple
              ></UploadCommon>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <addPhoto ref="addPhoto" :type="source.type" />
      <AddPay
        ref="addPay"
        :addPayList="addPayList"
        :dataList="source.maintenanceItemInfo"
        :type="source.type"
        :countAllPay="source.totalAmount"
        @countAllPay="changeAllPay"
        @totalDisabled="val => (this.totalDisabled = val)"
      />
      <editDriverWarningPay
        :type="source.type"
        :driverWarningPayData="driverWarningPayData"
      />
      <div class="splitline mt16 mb16" />
      <template slot="bottomAction">
        <el-button
          type="primary"
          @click="saveSubmit"
          size="small"
          :loading="oLoading.submit"
          >保存提交</el-button
        >
        <el-button size="small" @click="goPageBack">取消</el-button>
      </template>
    </QS-scroller-box>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import { providerList } from '@/api/domain/organize'
import {
  maintenanceDetail,
  maintenanceEdit,
  queryByType,
} from '@/api/domain/carsService'
import selectOption from '@/store/dict/selectOptionDict'
import AddPay from '../components/addPay.vue'
import addPhoto from '../components/addPhoto.vue'
import editDriverWarningPay from '../components/editDriverWarningPay'
import { parseTime } from '@/utils'
import WindowCommunication from '@/utils/windowCommunication'

export default {
  components: {
    AddPay,
    addPhoto,
    editDriverWarningPay,
  },
  data() {
    return {
      oLoading: {
        detail: false,
        submit: false,
      },
      list: [
        {
          key: 'plateNo',
          name: '车牌号',
        },
        {
          key: 'brandName',
          name: '品牌',
        },
        {
          key: 'seriesName',
          name: '车系',
        },
        {
          key: 'modelName',
          name: '车型',
        },
        {
          key: 'carId',
          name: '车辆ID',
        },
        {
          key: 'customerName',
          name: '当前客户',
        },
        {
          key: 'customerId',
          name: '客户ID',
        },
        {
          key: 'contractId',
          name: '订单ID',
        },
      ],
      labelWidth: '120px',
      source: {
        type: '',
        providerId: '',
        incomeTime: '',
        incomeKm: '',
        leaveTime: '',
        customerAmount: '',
        totalAmount: '',
        maintenanceState: '',
        settlementState: '',
        remarks: '',
        attachment: {},
        reasonForRepair: '',
        expenseBearingParty: '',
        estimateLeaveTime: '',
        lastMaintenanceKm: '',
        overMaintenanceKm: '',
      },
      // 司机警示金
      driverWarningPayData: {
        exceedAmount: '',
        floatAmount: '',
        depreciationAmount: '',
      },
      /* 上传假数据 */
      fileList: [],
      // 表格数据
      rules: {
        plateNo: [
          { required: true, message: '车牌号不能为空', trigger: 'blur' },
        ],
        type: [
          { required: true, message: '维保类型不能为空', trigger: 'change' },
        ],
        providerId: [
          { required: true, message: '不能为空', trigger: 'change' },
        ],
        incomeTime: [
          {
            required: true,
            message: '进厂时间不能为空',
            trigger: 'blur',
          },
        ],
        incomeKm: [
          { required: true, message: '进厂公里数不能为空', trigger: 'blur' },
        ],
        totalAmount: [
          {
            required: true,
            message: '维保总费用不能为空',
            trigger: 'blur',
          },
        ],
        customerAmount: [
          {
            required: true,
            message: '客户承担总金额不能为空',
            trigger: 'blur',
          },
        ],
        // leaveTime: [
        //   { required: true, message: '出厂时间不能为空', trigger: 'blur' }
        // ],
        maintenanceState: [
          { required: true, message: '维保状态不能为空', trigger: 'change' },
        ],
        settlementState: [
          { required: true, message: '结算状态不能为空', trigger: 'change' },
        ],
        expenseBearingParty: [
          { required: true, message: '费用承担方不能为空', trigger: 'change' },
        ],
      },
      optionsPayee: [],
      options: [],
      addPayList: [],
      totalDisabled: true,
    }
  },
  mounted() {
    // 调用修理厂接口
    this.getProvider()
  },
  methods: {
    // 获取详情信息
    async getList(res) {
      if (!res.id) return
      // if (!this.$route.query.id) return
      this.oLoading.detail = true
      try {
        const { code, data } = await maintenanceDetail(res)
        data.incomeKm = data?.incomeKm ? String(data.incomeKm) : ''
        this.oLoading.detail = false
        if (code === 1) {
          this.optionsPayee = this.options.filter(
            (item) => item.id === data.providerId,
          )
          if (this.optionsPayee.length > 0) {
            this.source = data
            this.handleType(data.type) // 初始化添加型选择
          } else {
            this.source = { ...data, providerId: '' }
          }
          this.fileList = this.getEchoUploadFileData(data.attachment, true)
          this.driverWarningPayData.exceedAmount = data.exceedAmount || ''
          this.driverWarningPayData.floatAmount = data.floatAmount || ''
          this.driverWarningPayData.depreciationAmount =
            data.depreciationAmount || ''
          this.$refs.addPhoto.form = this.imageFilter(data.photo)
        }
      } catch (error) {
        this.oLoading.detail = false
      }
    },
    // 获取修理厂列表
    async getProvider() {
      const { code, data } = await providerList({
        serviceType: 1,
        state: 1,
      })
      if (code === 1) {
        this.options = data.items
        this.getList({
          id: this.$route.query.id,
        })
      }
    },
    /* 保存提交按钮 */
    saveSubmit() {
      let status = false
      const payParam = this.$refs.addPay.handleValidate()
      this.$refs.source_from.validate((volid) => {
        status = volid
      })
      if (status && payParam) {
        this.source.itemsList = payParam
        this.source.attachment = this.getUoloadCommonFileData(this.fileList)
        const tempDriverWarningPayData = this.driverWarningPayData
        Object.keys(tempDriverWarningPayData).forEach((key) => {
          if (!tempDriverWarningPayData[key]) { tempDriverWarningPayData[key] = '0.00' }
        })
        const source = {
          ...this.source,
          ...tempDriverWarningPayData,
          photo: this.imageString(),
        }
        this.getEdit(source)
      } else {
        this.$message.error(
          payParam ? '请填写带有红色 * 的必填项' : '请完善维保添加项目',
        )
      }
    },
    /* 编辑接口 */
    async getEdit(res) {
      this.oLoading.submit = true
      try {
        const data = await maintenanceEdit(res)
        this.oLoading.submit = false
        if (data.code === 1) {
          this.$message.success('操作成功')
          this.goPageBack(true)
          this.sendMessage()
        }
      } catch (error) {
        this.oLoading.submit = false
      }
    },

    // 返回上一页
    goPageBack(status = false) {
      this.$refreshBack(status)
    },

    async handleType(type) {
      this.addPayList = []
      if (!type) return
      try {
        const { code, data } = await queryByType({ type })
        if (code === 1 && Array.isArray(data) && data.length) {
          this.addPayList = data
        }
      } catch (error) {
        console.warn('维保项目抱错接口', error)
      }
    },
    changeAllPay({ customerMaintenanceAmountTotal, resStove }) {
      // 维保总费用
      if (this.source.totalAmount !== resStove) {
        this.source.totalAmount = resStove
      }
      // 客户承担维保金额
      if (this.source.customerAmount !== customerMaintenanceAmountTotal) {
        this.source.customerAmount = customerMaintenanceAmountTotal
      }
    },
    // 处理备注
    changeRemarks(val) {
      if (val) {
        // eslint-disable-next-line no-misleading-character-class, no-useless-escape
        const regStr = /([0-9|*|#]\uFE0F\u20E3)|([0-9|#]\u20E3)|([\u203C-\u3299]\uFE0F\u200D)|([\u203C-\u3299]\uFE0F)|([\u2122-\u2B55])|(\u303D)|([(\A9)|(\AE)]\u3030)|(\uA9)|(\uAE)|(\u3030)|([\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF])|([\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F])/g
        if (regStr.test(val)) {
          const str = val.replace(regStr, '')
          // val = str
          this.$set(this.source, 'remarks', str)
        }
      }
    },
    // 送修原因
    changeReasonForRepair(val) {
      if (val) {
        // eslint-disable-next-line no-misleading-character-class, no-useless-escape
        const regStr = /([0-9|*|#]\uFE0F\u20E3)|([0-9|#]\u20E3)|([\u203C-\u3299]\uFE0F\u200D)|([\u203C-\u3299]\uFE0F)|([\u2122-\u2B55])|(\u303D)|([(\A9)|(\AE)]\u3030)|(\uA9)|(\uAE)|(\u3030)|([\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF])|([\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F])/g
        if (regStr.test(val)) {
          const str = val.replace(regStr, '')
          // val = str
          this.$set(this.source, 'reasonForRepair', str)
        }
      }
    },
    // 图片处理
    imageFilter(data) {
      const defaultValue = {
        enterFactoryPictures: [],
        maintenancePictures: [],
        accidentScenePictures: [],
        responsibilityPictures: [],
        lossOrderPictures: [],
      }
      if (!data || data === '{}') return defaultValue
      const result =
        typeof data === 'string' && JSON.parse(data) ? JSON.parse(data) : data
      if (!result) return defaultValue
      for (const key in result) {
        if (Object.prototype.hasOwnProperty.call(result, key)) {
          result[key] = this.getEchoUploadFileData(result[key], true)
        }
      }
      return result
    },
    imageString() {
      const obj = { ...this.$refs.addPhoto.form }
      for (const key in obj) {
        obj[key] = this.getUoloadCommonFileData(obj[key], false) || []
      }
      return JSON.stringify(obj)
    },
    sendMessage() {
      // 跨页面通信 通知签约提车车辆状态信息刷新
      if (this.$route.query.scene) {
        const communication = new WindowCommunication('person_sign_contract')
        communication.send({
          type: 'unavailable_message',
          data: true,
        })
        // 关闭window
        window.close()
      }
    },
  },
  computed: {
    // 维保类型
    maintenanceTypList() {
      return this.dictParseList(selectOption.maintenanceTypeDict)
    },
    // 维保状态
    maintenanceStateList() {
      return this.dictParseList(selectOption.maintenanceStateDict).filter(
        (item) => item.value !== 5,
      )
    },
    // 结算状态
    settlementStatusList() {
      return this.dictParseList(selectOption.settlementStatusDict)
    },
    //  出厂时间选择
    leaveTimeOption() {
      // 出厂时间 >= 进厂时间
      let result = this.source.incomeTime
      result = result && result.split(' ')[0]
      return {
        disabledDate: (time) => {
          if (!result) return false
          time = parseTime(time.getTime(), '{y}-{m}-{d}')
          return time < result
        },
      }
    },
    // 计划出厂时间选择
    estimateLeaveTimeOption() {
      let result = this.source.incomeTime
      result = result && result.split(' ')[0]
      return {
        disabledDate: (time) => {
          if (!result) return false
          time = parseTime(time.getTime(), '{y}-{m}-{d}')
          return time < result
        },
      }
    },
    // 进厂时间
    incomeTimeOption() {
      const leaveTime = new Date(this.source.leaveTime).getTime() // 出厂时间
      const estimateLeaveTime = new Date(
        this.source.estimateLeaveTime,
      ).getTime() // 计划出厂时间
      let result = null
      if (leaveTime && estimateLeaveTime) {
        if (leaveTime > estimateLeaveTime) result = estimateLeaveTime
        else if (leaveTime < estimateLeaveTime) result = leaveTime
        else result = leaveTime || estimateLeaveTime
      } else if (leaveTime) result = leaveTime
      else if (estimateLeaveTime) result = estimateLeaveTime
      else result = 0
      return {
        disabledDate: (time) => {
          if (!this.source.leaveTime && !this.source.estimateLeaveTime) { return false }
          time = time.getTime()
          return Number(time) > Number(result)
        },
      }
    },
  },
}
</script>

<style lang="less" scoped>
// ::v-deep .el-form-item__content {
//   margin-left: 0 !important;
// }
.content1 {
  margin-bottom: 24px;
}
.infor {
  ::v-deep .el-input--small {
    max-width: 220px;
  }
}

::v-deep .el-form-item__content {
  // margin-left: 0 !important;
}
.specail_upload {
  ::v-deep .el-form-item__content {
    // margin-left: 140px !important;
    // margin-top: -30px;
  }
  ::v-deep .upload-box.textType {
    width: 222px !important;
  }
  ::v-deep .el-upload {
    width: 220px !important;
  }
  ::v-deep .el-upload-dragger {
    width: 220px !important;
  }
  ::v-deep .upload-box .textType-box .filelist-ul ._info .txt {
    width: 100px;
  }
}
</style>
